// extracted by mini-css-extract-plugin
export default {"container":"CylmGxvxiNuF75tbH7Bu","headerWrapper":"Wh0sL3m3t37V36Ao1WqW","titleWrapper":"NflWhXZ_ZI7B6o8ZfBAD","icon":"OymcNQht0Rb6IcamSTwV","title":"p7Qd6eQ1vhbcEXOEh7TN"};